import axios from "axios";
import moment from "moment";
import { msalInstance } from "./msalInstance";
import { apiRequest } from "./authConfig";

const apiBaseUrl = "https://fa-backupautomation01-hgegfah8gnc4avbv.switzerlandnorth-01.azurewebsites.net/api";
// const apiBaseUrl = "http://localhost:7071/api";

// Axios interceptor to add authentication token
axios.interceptors.request.use(async (config) => {
  if (config.url?.startsWith(apiBaseUrl)) {
    try {
      const account = msalInstance.getActiveAccount();
      if (account) {
        const response = await msalInstance.acquireTokenSilent({
          ...apiRequest,
          account: account
        });
        config.headers.Authorization = `Bearer ${response.accessToken}`;
      }
    } catch (error) {
      console.error("Failed to acquire token", error);
      // Optionally redirect to login
      // msalInstance.acquireTokenRedirect(apiRequest);
    }
  }
  return config;
});

const getBackupItems = async (filter) => {
  // make a post request with filter {filter: {}} to /queryBackupItems
  const response = await axios.post(`${apiBaseUrl}/queryBackupItems`, {
    filter: filter,
    history: false
  });

  return response.data?.data || [];
}

const getBackupItem = async (backupItemId) => {
  const response = await axios.get(`${apiBaseUrl}/backupItem/${backupItemId}`);
  return response.data?.data || {};
}

const lastSuccessBackupItems = async (numberOfDays) => {
  // Calculate the deadline date based on the number of days specified
  let deadline = moment().subtract(numberOfDays, "day").toDate();

  let filter = {
    $and: [
      { 'lifecycle.status': 'active' },
      {
        $or: [
          { lastSuccessTime: { $lt: deadline } },
          { lastSuccessTime: { $exists: false } }
        ]
      }
    ]
  };

  let lastSuccessBackupItems = await getBackupItems(filter);

  return lastSuccessBackupItems;
};

const getArchivedBackupItems = async () => {
  let filter = {
    'lifecycle.status': 'archived'
  };
  return getBackupItems(filter);
};

const getMails = async(filter) => {
  const response = await axios.post(`${apiBaseUrl}/queryMails`, {
    filter: filter,
    fields: { status: 1, subject: 1, receivedDateTime: 1, from: 1, toRecipients: 1 }
  });
  return response.data?.data || [];
}

const getMail = async (mailId) => {
  const response = await axios.get(`${apiBaseUrl}/mail/${mailId}`);
  return response.data?.data || {};
}

const parseMail = async (mailId) => {
  const response = await axios.get(`${apiBaseUrl}/parseMail/${mailId}`);
  return response.data?.data || {};
}

const archiveBackupItem = async (backupItemId, reason, updatedBy) => {
  const response = await axios.post(`${apiBaseUrl}/archiveBackupItem/${backupItemId}`, { reason, updatedBy });
  return response.data?.data || {};
}

export { lastSuccessBackupItems, getBackupItem, getMail, getMails, parseMail, archiveBackupItem, getArchivedBackupItems };